import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from "@mui/material";
import { LoginV3AuthError, } from "generated/generated-models";
const generateErrorMessage = (error, data, isUsingGoogleAuth) => {
    if (error != null) {
        return "An error has occured during login";
    }
    switch (data?.loginV2?.AuthError) {
        case LoginV3AuthError.Invalidcredentials:
            return "Invalid Username or Password";
        case LoginV3AuthError.Mfatokeninvalid:
            return isUsingGoogleAuth
                ? "Invalid Auth Code"
                : "Invalid Security Token";
        case LoginV3AuthError.Newpasswordinvalid:
            return `New Password is invalid: ${data.loginV2.AuthMessage}`;
        case LoginV3AuthError.Passwordexpired:
            return "Your temporary password has expired";
        case LoginV3AuthError.Mfarequired:
        case LoginV3AuthError.Requirepasswordchange:
        default:
            return null;
    }
};
const LoginErrorMessage = ({ loginError, loginResponse, isUsingGoogleAuth, }) => {
    const errorMessage = generateErrorMessage(loginError, loginResponse, isUsingGoogleAuth);
    if (errorMessage == null) {
        return null;
    }
    return _jsx(Alert, { severity: "error", children: errorMessage });
};
export default LoginErrorMessage;
